import React, { useRef, useState, useEffect } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSearchProvidersContext } from '../../contexts/searchProviders';
import { useProvidersContext } from '../../contexts/providers';
import { briefSearchProviders } from '../../api/ecDataQueryApi';
import ProviderCarousel from '../home/ProviderCarousel';

export default ({
  searchable,
}) => {
  const { t } = useTranslation();
  const {
    searchProvidersConditions: searchProvidersConditionsCache,
    searchProvidersResults: searchProvidersResultsCache,
    set: setSearchProvidersConditionsAndResultsCache,
  } = useSearchProvidersContext();
  const {
    addProviders,
  } = useProvidersContext();

  const isSearchingRef = useRef(false);
  const [searchConditions, setSearchConditions] = useState(null);
  const [searchResult, setSearchResult] = useState(null);

  useEffect(() => {
    setSearchResult(null);
    setSearchConditions({
      ...(searchable ? { searchable } : {}),
    });
  }, [searchable]);

  useEffect(() => {
    if (
      isSearchingRef.current
      || _.isEmpty(searchConditions)
    ) return;
    (async () => {
      try {
        isSearchingRef.current = true;
        if (
          _.isEqual(searchConditions, searchProvidersConditionsCache)
        ) {
          setSearchResult(searchProvidersResultsCache);
        } else {
          const data = (await briefSearchProviders({
            ...searchConditions,
          })) || [];
          setSearchResult((oldSearchResult) => {
            const newResults = [
              ...(oldSearchResult || []),
              ...(data.map(({ key, value }) => {
                const parsedValue = JSON.parse(value);
                addProviders(key, parsedValue);
                return key;
              })),
            ];
            setSearchProvidersConditionsAndResultsCache(searchConditions, newResults);
            return newResults;
          });
        }
        isSearchingRef.current = false;
      } catch (error) {
        console.error(error);
      }
    })();
  }, [searchConditions, setSearchProvidersConditionsAndResultsCache,
    searchProvidersConditionsCache, searchProvidersResultsCache, addProviders,
  ]);

  return (!searchResult || searchResult.length === 0) ? null : (
    <ProviderCarousel
      name={t('ec.search_result_providers')}
      providers={searchResult}
      showMoveButtons={false}
      align="left"
      titleStyle={{ transform: 'translateY(-50%)', padding: 0 }}
    />
  );
};
